module.exports = __webpack_public_path__ + "media/brands/master-3bcce5db.png";